export enum UserRole {
  Admin = 'Admin',
  Builder = 'Builder',
  Viewer = 'Viewer',
  Superadmin = 'Superadmin',
  Guest = 'Guest'
}

export enum UserRoleLabels {
  Admin = 'Admin',
  Builder = 'Editor',
  Viewer = 'Viewer',
  Superadmin = 'Superadmin',
  Guest = 'Guest viewer'
}

export enum LogInProviders {
  GitHub = 'github',
  Google = 'google-oauth2',
  Samlp = 'samlp',
  Auth0 = 'auth0'
}

export interface UserIdentity {
  access_token: string
  connection: string
  expires_in: number
  isSocial: boolean
  provider: LogInProviders
  user_id: string
}

export interface User {
  user_id: string
  name: string
  nickname: string
  user_metadata: UserMetadata
  app_metadata: {
    roles: UserRole[]
  }
  created_at: string
  email: string
  email_verified: boolean
  family_name?: string
  given_name?: string
  identities?: UserIdentity[]
  last_ip?: string
  last_login?: string
  locale?: string
  logins_count?: number
  picture?: string
  updated_at?: string
  grantedEmail?: string | null
}

export enum UserAccountJoinRequestStatus {
  Waiting = 'waiting',
  Declined = 'declined', // not seen in a wild
  Approved = 'approved'
}

export interface UserMetadata {
  account_id: string
  account_name: string
  account_join_request?: UserAccountJoinRequestStatus
  tenant_domain: string
  tenant_id?: string
  org_id?: string
  invitationToken?: string
  is_carto_user?: boolean
}

export enum AccountCreationProcess {
  IsBeingCreated = 404,
  Created = 204
}

export interface AvatarData {
  userImage?: string
  acronym?: string
  email?: string
}
